module.exports = __webpack_public_path__ + "static/media/radio-1.814ee3f0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/radio-1.svg
// module id = ./src/assets/images/radio-1.svg
// module chunks = 0